import * as PasswordToggleField from '@radix-ui/react-password-toggle-field';
import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { Icon } from './Icon';
import { inputFieldClasses, inputSizeClasses, type InputSize } from './Input';

type PasswordInputProps = Omit<React.ComponentPropsWithoutRef<typeof PasswordToggleField.Input>, 'size'> & {
  inputSize?: InputSize;
};

/**
 * Password field with a show/hide toggle (uses Radix)
 */
export const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ inputSize = 'md', className, ...rest }, ref) => {
    return (
      <PasswordToggleField.Root>
        <div className={twMerge('relative w-full', className)}>
          <PasswordToggleField.Input
            ref={ref}
            className={twMerge(inputFieldClasses, inputSizeClasses[inputSize], 'pr-9')}
            {...rest}
          />
          <PasswordToggleField.Toggle className="text-text-3 hover:text-text-1 focus-visible:border-primary-9 absolute top-1/2 right-1.5 flex h-7 w-7 -translate-y-1/2 cursor-pointer items-center justify-center rounded-[4px] border border-transparent transition-colors outline-none">
            <PasswordToggleField.Icon
              className="size-4"
              visible={<Icon symbol="eye-line" />}
              hidden={<Icon symbol="eye-off-line" />}
            />
            <PasswordToggleField.Slot
              render={({ visible }) => <span className="sr-only">{visible ? 'Hide password' : 'Show password'}</span>}
            />
          </PasswordToggleField.Toggle>
        </div>
      </PasswordToggleField.Root>
    );
  },
);
PasswordInput.displayName = 'PasswordInput';
